exports.disableInstallBrowsers = ['opera', 'ecosia android', 'ecosia ios'];
exports.SUPPORTED_SAFARI_VERSION = 14;
exports.EDGE_LEGACY_VERSION = 18;
exports.blockedBrowsers = ['vivaldi', 'iemobile', 'opera', 'waterfox'];
exports.supportedDesktopBrowsers = [
  'chrome',
  'firefox',
  'safari',
  'edge',
];
exports.supportedMobileBrowsers = [
  'android',
  'ios',
];
